/* eslint-disable global-require */

'use-strict';

import { RouteProvider } from '../../app.upgraded.routes';

/* @ngInject */
export default function routing($routeProvider: RouteProvider): void {
  $routeProvider
    // INTRO
    .when('/sales/add-vehicle', {
      templateUrl: require('./import-intro.template.html'),
      title: 'Fahrzeug hinzufügen',
    })
    .when('/sales/add-vehicle/:vin', {
      templateUrl: require('./import-intro.template.html'),
      title: 'Fahrzeug hinzufügen',
    });
}
